module.exports = __webpack_public_path__ + "media/images/application/icons/contact-b61f266f84be6826d3b83b10da35426f.svg";